import { render, staticRenderFns } from "./ChatInfo.vue?vue&type=template&id=109f80e6&scoped=true&"
import script from "./ChatInfo.vue?vue&type=script&lang=js&"
export * from "./ChatInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChatInfo.vue?vue&type=style&index=0&id=109f80e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109f80e6",
  null
  
)

export default component.exports